import { CompanyMetric } from "../../models/tableModels";
import { FlagKey } from "../../models/workflowModels";
import { Filter } from "../../types/PageFilterTypes";

const BASE_METRIC_FILTER: Filter[] = [
  { key: "Base_Year", displayValue: "Base Year" },
];

export function getMockData(filters: Filter[]): CompanyMetric[] {
  const mockMetrics: CompanyMetric[] = [];
  filters = filters.concat(BASE_METRIC_FILTER);
  const count = 40;

  const baseAttributes = {
    name: "Generic Company",
    currency: "USD",
    added_on: new Date().toISOString(),
    image: "https://example.com/default_image.png",
    revenue: 5000,
    metric_type: "Example Type",
    holding_weight: 0.05,
    geo_level_2: "US",
    gics_sector_name: "Industrials",
  };

  for (let i = 1; i <= count; i++) {
    filters.forEach((filter) => {
      mockMetrics.push({
        ...baseAttributes,
        name: `${baseAttributes.name} ${i}`,
        compass_cid: `CID ${i}`,
        metric_id: filter.key as string,
        value_numeric: Math.random() * 1000,
        value_text: null,
        portfolio_index_id: `Portfolio ${i}`,
        Compass_Metric_Display_Name: filter.displayValue,
        image: `https://example.com/image_${i}.png`,
        revenue: baseAttributes.revenue + i * 1000,
        flag_status: FlagKey.RESOLVED,
        Is_Numeric: false,
      });
    });
  }

  return mockMetrics;
}
